import { render, staticRenderFns } from "./QType2Answer.vue?vue&type=template&id=2dbe0cec&scoped=true&"
import script from "./QType2Answer.vue?vue&type=script&lang=js&"
export * from "./QType2Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType2Answer.vue?vue&type=style&index=0&id=2dbe0cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe0cec",
  null
  
)

export default component.exports